export default {
  BusinessOrderPreemptGoods: {
    skuTitle: 'Summary by commodity',
    skuItemTitle: 'Detail by commodity line',
    reReserve: 'Re-reserve',
    reReserveConfirmText1: 'Whether to confirm re-reserve？',
    Uncamp: 'Uncamp',
    preemptConfirmText: 'Is it confirmed to release the reservation？'
  },
  BusinessOrderPreemptGoodsSku: {
    preemptionStatus: 'Reservation Status',
    reReserve: 'Re-reserve',
    Uncamp: 'Uncamp',
    reserve: 'To be reserved',
    reserveOk: 'Successfully preempted',
    reserveFail: 'Preemption failure',
    hangUp: 'Hang up',
    giveaway: 'Is it a gift',
    sourceStatus: 'Sourcing Status',
    virtualWarehouseName: 'Reserve a virtual position',
    failReason: 'Failure reason',
    productLineTotal: 'Product line total',
    quantity: 'Number of Products',
    other: 'Other Information',
    msgWarning: 'The returned data is empty, please contact the administrator'
  }
};
